import className from "classnames/bind";

import { useCurrentLocale } from "@/context/LanguageContext";

import Header from "../../text/header";
import styles from "./article-header.module.scss";

const cx = className.bind(styles);

export const ArticleHeader = ({ title }: { title: string }): React.ReactElement => {
    const locale = useCurrentLocale();
    const headerClassNames = cx({
        nonArcadeHeader: locale !== "en-US",
    });

    return <Header renderAs="h4" className={headerClassNames} title={title} />;
};
